import {BASE_AGGREGATION} from 'pipelines/formula/functions/BaseFunctions';

import {AnalysisFunction} from '../FunctionTypes';

export default {
  ...BASE_AGGREGATION,
  name: 'MODE',
  description:
    'Mode of all numbers in a single column OR across each row of multiple columns. Single numbers are treated as columns containing only that number.',
  shortDescription: 'Mode',
} satisfies AnalysisFunction;
